import { TWIST_GENERATOR_OPTIONS } from '../TWIST_GENERATOR_OPTIONS';
import { TwistGeneratorOptionIdType } from '../types';

const DEFAULT_ID: TwistGeneratorOptionIdType = 'its_your_ex';
const DEFAULT_TITLE = TWIST_GENERATOR_OPTIONS[1].title; // its_your_ex option

export const getTwistGeneratorChoiceIdByTitle = (
  title: string | null | undefined,
  withDefault = false,
): TwistGeneratorOptionIdType | null => {
  const id = TWIST_GENERATOR_OPTIONS.find(
    (option) => option.title === title,
  )?.id;

  if (id) {
    return id;
  }

  if (withDefault) {
    return DEFAULT_ID;
  }

  return null;
};

export const getTwistGeneratorChoiceTitleById = (
  id: TwistGeneratorOptionIdType | null | undefined,
  withDefault = false,
): string | null => {
  const title = TWIST_GENERATOR_OPTIONS.find(
    (option) => option.id === id,
  )?.title;

  if (title) {
    return title;
  }

  if (withDefault) {
    return DEFAULT_TITLE;
  }

  return null;
};
